export function shouldSkipViralizeIntroVideo(input: {
  hasCourseAccess: boolean;
  replayQuestionnaire?: boolean;
}): boolean {
  return input.hasCourseAccess && input.replayQuestionnaire !== true;
}
